import { AccountSitePopupComponent } from './account-site-popup/account-site-popup.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login.component';
import { LegalAgreementComponent } from './legal-agreement/legal-agreement.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

export const LOGIN_DECLARATIONS: any[] = [
  LoginComponent,
  LegalAgreementComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
  AccountSitePopupComponent
];
